// extracted by mini-css-extract-plugin
export default {"standard":"template_standard__-1jPp","login":"template_login__HGnMj","forget":"template_forget__g7STR","forget__inner":"template_forget__inner__q-+Sh"};